import { PaginationAttribute } from 'bernie-http';
const CHINA_POS_SITE_ID = 100001;
export const getSeoData = context => {
  var _a;
  const additionalMeta = [new PaginationAttribute('preconnect', 'https://images.trvl-media.com/')];
  ((_a = context === null || context === void 0 ? void 0 : context.site) === null || _a === void 0 ? void 0 : _a.id) !== CHINA_POS_SITE_ID && additionalMeta.push(new PaginationAttribute('preconnect', 'https://maps.googleapis.com/'));
  return {
    seo: Object.assign({
      additionalMeta
    }, (context === null || context === void 0 ? void 0 : context.seoData) && {
      canonical: context === null || context === void 0 ? void 0 : context.seoData.url
    })
  };
};